import { Col } from 'antd'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import React from 'react'

import './shipOverviewTab.less'
import BaplieOrRestow from './BaplieOrRestow'
import FeatureAccessControl from 'components/FeatureAccessControl'
import featureCodes from 'constants/featureCodes'
import GearboxLocations from './GearboxLocations'
import ShipOverview from './ShipOverview/ShipOverview'
import VesselDraftsTable from './VesselDraftsTable/VesselDraftsTable'

const ShipOverviewTab = ({
  baplieRestowHistory,
  baplieRestowHistoryError,
  baplieRestowDownloadError,
  baplieUploadError,
  draftSurvey: {
    arrivalDrafts,
    arrivalWaterDensity,
    departureDrafts,
    departureWaterDensity,
  },
  draftSurveySaveError,
  gearboxLocations,
  isBaplieRestowHistoryLoading,
  isDraftSurveyLoading,
  isGearboxLocationsLoading,
  isPortCallClosed,
  isDownloadingBaplieRestow,
  isUploadingBaplieRestow,
  isShipOverviewLoading,
  isSavingDraftSurvey,
  onDownloadBaplieRestow,
  onUploadBaplieRestow,
  onSavePortCallDraftSurvey,
  onUnlockDeviceBay,
  portCallBaplieRestowUploadFailed,
  setSavePortCallDraftSurveyError,
  setUnlockDeviceBayError,
  shipOverview,
  shouldShowLoadingSkeleton,
  unlockDeviceBayError,
  unlockingDeviceId,
  userRole,
}) => (
  <Col span={24}>
    <div className="grid-gap ship-overview-tab__container">
      <FeatureAccessControl
        featureCode={featureCodes.SHOW_BAPLIE_OR_RESTOW_COMPONENT}
      >
        <BaplieOrRestow
          baplieData={baplieRestowHistory}
          downloadError={baplieRestowDownloadError}
          hasError={baplieRestowHistoryError}
          isDownloading={isDownloadingBaplieRestow}
          isLoading={isBaplieRestowHistoryLoading && shouldShowLoadingSkeleton}
          isPortCallClosed={isPortCallClosed}
          isUploading={isUploadingBaplieRestow}
          onDownload={onDownloadBaplieRestow}
          onUpload={onUploadBaplieRestow}
          portCallBaplieRestowUploadFailed={portCallBaplieRestowUploadFailed}
          uploadError={baplieUploadError}
          userRole={userRole}
        />
      </FeatureAccessControl>

      {!isPortCallClosed && (
        <ShipOverview
          isLoading={isShipOverviewLoading && shouldShowLoadingSkeleton}
          isUnlockingDeviceId={unlockingDeviceId}
          onClearUnlockDeviceError={() => setUnlockDeviceBayError(null)}
          onUnlockDevice={onUnlockDeviceBay}
          shipOverviewData={shipOverview}
          unlockDeviceError={unlockDeviceBayError}
        />
      )}

      <GearboxLocations
        isLoading={isGearboxLocationsLoading && shouldShowLoadingSkeleton}
        locations={gearboxLocations}
      />

      <VesselDraftsTable
        draftSurveySaveError={draftSurveySaveError}
        drafts={arrivalDrafts}
        isArrivalDrafts
        isLoading={isDraftSurveyLoading && shouldShowLoadingSkeleton}
        isPortCallClosed={isPortCallClosed}
        isSavingDraftSurvey={isSavingDraftSurvey}
        onSavePortCallDraftSurvey={onSavePortCallDraftSurvey}
        setSavePortCallDraftSurveyError={setSavePortCallDraftSurveyError}
        waterDensity={arrivalWaterDensity}
      />

      <VesselDraftsTable
        draftSurveySaveError={draftSurveySaveError}
        drafts={departureDrafts}
        isLoading={isDraftSurveyLoading && shouldShowLoadingSkeleton}
        isPortCallClosed={isPortCallClosed}
        isSavingDraftSurvey={isSavingDraftSurvey}
        onSavePortCallDraftSurvey={onSavePortCallDraftSurvey}
        setSavePortCallDraftSurveyError={setSavePortCallDraftSurveyError}
        waterDensity={departureWaterDensity}
      />
    </div>
  </Col>
)

ShipOverviewTab.defaultProps = {
  baplieRestowDownloadError: null,
  baplieRestowHistory: [],
  baplieUploadError: null,
  shipOverview: null,
  unlockDeviceBayError: null,
  unlockingDeviceId: null,
}

ShipOverviewTab.propTypes = {
  baplieRestowDownloadError: PropTypes.string,
  baplieRestowHistory: PropTypes.array,
  baplieRestowHistoryError: PropTypes.bool.isRequired,
  baplieUploadError: PropTypes.string,
  draftSurvey: propTypes.draftSurvey,
  draftSurveySaveError: PropTypes.string,
  gearboxLocations: PropTypes.arrayOf(PropTypes.string).isRequired,
  isBaplieRestowHistoryLoading: PropTypes.bool.isRequired,
  isDownloadingBaplieRestow: PropTypes.bool.isRequired,
  isDraftSurveyLoading: PropTypes.bool.isRequired,
  isGearboxLocationsLoading: PropTypes.bool.isRequired,
  isPortCallClosed: PropTypes.bool.isRequired,
  isSavingDraftSurvey: PropTypes.bool.isRequired,
  isShipOverviewLoading: PropTypes.bool.isRequired,
  isUploadingBaplieRestow: PropTypes.bool.isRequired,
  onDownloadBaplieRestow: PropTypes.func.isRequired,
  onSavePortCallDraftSurvey: PropTypes.func.isRequired,
  onUnlockDeviceBay: PropTypes.func.isRequired,
  onUploadBaplieRestow: PropTypes.func.isRequired,
  portCallBaplieRestowUploadFailed: PropTypes.func.isRequired,
  setSavePortCallDraftSurveyError: PropTypes.func,
  setUnlockDeviceBayError: PropTypes.func.isRequired,
  shipOverview: propTypes.shipOverview,
  shouldShowLoadingSkeleton: PropTypes.bool.isRequired,
  unlockDeviceBayError: PropTypes.string,
  unlockingDeviceId: PropTypes.string,
  userRole: propTypes.userRole,
}

export default ShipOverviewTab
